import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

export const useStatsStore = defineStore('stats', () => {
  const stats = ref<any>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchAdventurerStats = async (expeditionId: string | number | null) => {
    if (!expeditionId) {
      error.value = 'Missing expedition ID';
      return;
    }

    isLoading.value = true;
    error.value = null;

    try {
      const response = await api.get(API_ROUTES.GET_ADVENTURER_STATS(expeditionId as string));
      stats.value = response.data;
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch adventurer stats';
      console.error('Error fetching adventurer stats:', err);
    } finally {
      isLoading.value = false;
    }
  }

  return {
    stats,
    isLoading,
    error,
    fetchAdventurerStats
  }
})